import { render, staticRenderFns } from "./commonWeekSelect.vue?vue&type=template&id=36502e4a&scoped=true"
import script from "./commonWeekSelect.vue?vue&type=script&lang=js"
export * from "./commonWeekSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36502e4a",
  null
  
)

export default component.exports